'use strict';

angular.module('AcaApp').directive('ngIsFocus', [
  '$timeout',
  function($timeout){
    return {
      restrict: 'A',
      link: function($scope, element, attrs){
        $scope.$watch(attrs.ngIsFocus, function(value){
          if(value === true){
            $timeout(function(){
              element[0].focus();
              $scope[attrs.ngIsFocus] = false;
            });
          }
        });

        if(attrs.targetButtonId){
          var btn = (element.parent().find('#' + attrs.targetButtonId));
          btn.click(function(){
            element.focus();
          });
        }
      }
    };
  }
]);